<app-section-layout [dataForChart]="graphData" [itemTemplate]="epsGraph"></app-section-layout>

<ng-template #epsGraph let-data="data">
    <app-eps-slide [data]="data"></app-eps-slide>
</ng-template>